import { Paragraph, Spinner } from '@welbe/web-design-system';
import React from 'react';
import { FiPaperclip } from 'react-icons/fi';
import { getPdfOrders } from 'services/services';
import { loggerInfo } from 'utils/infoLog';
import { Container } from './DownloadOrdersButton.styles';
import { useToast } from '@welbe/web-design-system';

type DownloadOrdersButtonProps = {
	disabled?: boolean;
	id: string;
	name: string;
};

const getColor = (id?: string, disabled?: boolean) => {
	if (disabled || !id) {
		return '#d8dee6';
	}

	return '#5082C2';
};

const getText = (id?: string, disabled?: boolean) => {
	if (disabled) {
		return 'Espera...';
	}

	if (id) {
		return 'Ver folios';
	}

	return 'Sin folios';
};

export const DownloadOrdersButton = ({
	id,
	name,
	disabled,
}: DownloadOrdersButtonProps) => {
	const { toast } = useToast();
	const [loading, setLoading] = React.useState(false);
	const handleError = (error: any) => {
		const statusError: any = {
			500: 'Ocurrió un error al descargar los folios',
			404: 'No se encontraron folios',
		};
		toast.error(statusError[error.response?.status] || 'Ocurrió un error');
		loggerInfo({
			data: error,
			context: 'hra',
			location: 'DownloadOrdersButton',
			payloadRequest: { id },
		});
	};

	const fetchFile = (url: string) => {
		const link = document.createElement('a');
		link.setAttribute('href', url);
		link.setAttribute('target', '_blank');
		link.setAttribute('download', `${name} folios.pdf`);
		document.body.appendChild(link);
		link.click();
		link?.parentNode?.removeChild(link);
	};

	const handleDownload = async () => {
		try {
			setLoading(true);
			const { data } = await getPdfOrders(id);
			fetchFile(data.content.path);
		} catch (error) {
			handleError(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Container
			id={`download-${id}`}
			role="button"
			disabled={disabled}
			onClick={() => !loading && id && !disabled && handleDownload()}
		>
			{loading ? (
				<Spinner size="14px" />
			) : (
				<FiPaperclip
					color={getColor(id, disabled)}
					className="order-paperclip-icon"
				/>
			)}
			<Paragraph
				key={Number(disabled)}
				fontWeight="600"
				fontSize="12"
				textDecoration={disabled ? 'unset' : 'underline'}
				color={getColor(id, disabled)}
				cursor={disabled ? 'not-allowed' : 'pointer'}
			>
				{getText(id, disabled)}
			</Paragraph>
		</Container>
	);
};
